import createImmutableSelector from 'lib/immutable/selector'
import { IMovimientos } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getMovimientos = (state: any): IMovimientos => state.get('movimientosReducer')

export const movimientosSelector = createImmutableSelector(getMovimientos, (movimientos) => movimientos)
